// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-c2ed5dc0]:after{content:\" *\";color:red}", ""]);
// Exports
module.exports = exports;
